const style = (theme) => {
  const output = {
    root: {
      position: 'absolute',
      zIndex: 1,
      width: '100vw',
      height: '100vh',
      fallbacks: {
        height: '-webkit-fill-available',
      },
      top: 0,
      left: 0,
      backgroundColor: theme.colors[6],
    },
    videoWrapper: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0,
      animation: '$fadeIn 0.2s ease-in-out backwards',
      '& video': {
        objectFit: 'cover',
        objectPosition: '50% 50%',
        width: '100%',
        height: '100%',
      },
    },
    visible: {
      opacity: 1,
    },
    '@keyframes fadeIn': {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}

export default style
